// extracted by mini-css-extract-plugin
export default {"b":"sun_b__5cued","h":"sun_h__NpmAy","s2":"sun_s2__rIsUg","mar":"sun_mar__wZR3s","icon":"sun_icon__EPed4","text":"sun_text__KyuAL"};